export var BattleTacticType;
(function (BattleTacticType) {
    BattleTacticType[BattleTacticType["Affray"] = 0] = "Affray";
    BattleTacticType[BattleTacticType["Strike"] = 1] = "Strike";
    BattleTacticType[BattleTacticType["Domination"] = 2] = "Domination";
    BattleTacticType[BattleTacticType["Unknown"] = 3] = "Unknown";
})(BattleTacticType || (BattleTacticType = {}));
export const battleTacticTypeToString = (type) => {
    switch (type) {
        case BattleTacticType.Affray:
            return 'Affray';
        case BattleTacticType.Strike:
            return 'Strike';
        case BattleTacticType.Domination:
            return 'Domination';
    }
    return 'Unknown';
};
export const stringToBattleTacticType = (str) => {
    const lc = str.toLowerCase();
    if (lc === 'affray')
        return BattleTacticType.Affray;
    if (lc === 'strike')
        return BattleTacticType.Strike;
    if (lc === 'domination')
        return BattleTacticType.Domination;
    return BattleTacticType.Unknown;
};
